import React, { useState, useEffect } from "react";
import "./custom.css"; // Custom CSS for styling
import DocumentationViewer from "../components/DocumentationViewer";
import { useNavigate, useParams } from "react-router-dom";
import { markdownPaths } from "../types/markdownPaths";

// Define the available sections as a union type for better typing
type Section = "database" | "licenses";

const FAQPage: React.FC = () => {
  const navigate = useNavigate();
  const { section } = useParams<{ section: Section }>();
  const [selectedSection, setSelectedSection] = useState<Section>("database");

  // Update the selected section based on the URL parameter
  useEffect(() => {
    if (section) {
      setSelectedSection(section);
    }
  }, [section]);

  // Function to switch sections and update the URL
  const handleSectionChange = (section: Section) => {
    setSelectedSection(section);
    navigate(`/knowledge-hub/faq/${section}`);
  };

  return (
    <div className="api-concepts-page">
      {/* Horizontal Menu with Section Categories */}
      <nav className="api-concepts-menu bg-gray-100 p-4">
        <ul className="flex justify-center space-x-8">
          <li
            className={`cursor-pointer ${
              selectedSection === "database" ? "text-green-600 font-bold" : ""
            }`}
            onClick={() => handleSectionChange("database")}
          >
            Database
          </li>
          <li
            className={`cursor-pointer ${
              selectedSection === "licenses" ? "text-green-600 font-bold" : ""
            }`}
            onClick={() => handleSectionChange("licenses")}
          >
            Licenses
          </li>
        </ul>
      </nav>

      {/* Content Area */}
      <div className="content-area">
        {selectedSection === "database" && (
          <DocumentationViewer filePath={markdownPaths.FAQDatabseURL} />
        )}

        {selectedSection === "licenses" && (
          <DocumentationViewer filePath={markdownPaths.FAQLicensesURL} />
        )}
      </div>
    </div>
  );
};

export default FAQPage;
